// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { CustomEvent } from "../../../Utils/CustomEvents"

export class IIndicator
{
    public OnError: CustomEvent;
    // Событие - ошибка
    constructor()
    {
        this.OnError = new CustomEvent()
    }

    // Ссылка на кеш айтем.
    public get Parent(): any { return null }
    public set Parent(value: any) { }

    // Имя индикатора - ключ создания
    public get Name(): string { return "" }
    public set Name(value: string) { }

    // Период индикатора
    public get Period(): any { return 1 }

    // Цена, по которой будет построен данный индикатор

    public get PriceType(): any { return 1 }
    public set PriceType(value: any) { }

    // Уникальный ключ
    public get Key(): any { return null }

    // Символ, для которого производится расчет

    public get Symbol(): any { return null }
    public set Symbol(value: any) { }

    // Тип истории, по которой индикатор будет работать.

    public get HistoryType(): any { return null }

    // Список с данными

    public get Data(): any { return null }

    // Количество доступных точек

    public get Count(): any { return null }

    public get MainChart(): any { return null }
    public set MainChart(value: any) { }

    public get TimeFrameInfo(): any { return null }
    public set TimeFrameInfo(value: any) { }

    // для расчетов - нужно ли рефрешнуть индикатор по CIFile'y

    public get RecalculateRange(): any { return null }

    // Получить значение индикатора в точке
    GetValue(par0, par1) { }

    // Задать значение индикатора в точке
    SetValue(par0, par1, par2) { }

    // Пересчитать индикатор не полностью, а от начала истории на count баров
    Refresh(par0, par1) { }

    // Пересчитать значение индиктора в последней точке
    OnQuote(ci, callBound, callFromRefresh) { }

    // Вызывается кешем при добавлении нового интервала
    NextBar(callBound) { }

    Init(async) { }

    Complete() { }

}